import moment from 'moment';

export default {
  name: 'customDrop',
  displayName: 'Uploaded Encouragement',
  uniqKey: '_id',
  crudMapping: {
    // create: 'createDrop',
    readMany: 'customDrops',
    readOne: 'customDrop',
    // update: 'updateDrop',
    // delete: 'deleteDrop',
  },
  readOneSchema: {
    show: true,
  },
  readManySchema: {
    cellFormatter(value, object, fieldName) {
      if (fieldName === 'title') {
        if (value.length > 50) {
          return `${value.substring(0, 50)}...`;
        }
      }
      if (fieldName === '_id') {
        const date = new Date(parseInt(value.substring(0, 8), 16) * 1000);
        return moment(date).format('MM/DD/YYYY hh:mm a');
      }

      return value;
    },
    jsonSchema: {
      type: 'object',
      properties: {
        title: {
          type: 'string',
        },
        content: {
          type: 'string',
        },
        _id: {
          type: 'string',
          title: 'Created At',
        },
      },
    },
  },
  defaultSchema: {
    jsonSchema: {
      title: 'Uploaded Encouragement',
      type: 'object',
      required: [
        'title',
        'content',
      ],
      properties: {
        title: {
          type: 'string',
        },
        content: {
          type: 'string',
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/schemas/admin/customEncouragement.js